import { Text } from 'bold-ui'
import { SelectField, SelectFieldProps } from 'components/form'

import { EspecialidadeModel } from '../../model-compartilhamentocuidado'

type CompartilhamentoCuidadoEspecialidadeSelectFieldProps = DistributiveOmit<
  SelectFieldProps<EspecialidadeModel>,
  'itemToString'
> & {
  items: EspecialidadeModel[]
}

export function CompartilhamentoCuidadoEspecialidadeSelectField(
  props: CompartilhamentoCuidadoEspecialidadeSelectFieldProps
) {
  return <SelectField<EspecialidadeModel> itemToString={itemToString} renderItem={renderItem} {...props} />
}

const itemToString = (option: EspecialidadeModel) => option?.nome

const renderItem = (item: EspecialidadeModel) => <Text>{item.nome}</Text>
